import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  loadTrendingTopicsForUser,
  saveTrendingTopicForUser,
} from '../../store/content/actions';
import { AppState } from '../../store';
import { ContentDisplayLoadingStatus } from '../../store/content/types';
import styles from './suggestedtopics.module.scss';
import { TopicViewModel } from '../../model/topic/types';

const SuggestedTopics: React.FC = () => {
  const { trendingTopics, status } = useSelector(
    (state: AppState) => state.content
  );

  const user = useSelector((state: AppState) => state.auth.user);
  const [accessToken, setAccessToken] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      typeof user !== 'undefined' &&
      !(user?.expired ?? true) &&
      (user?.access_token ?? '') !== ''
    ) {
      setAccessToken(user.access_token);
    }
  }, [user]);

  useEffect(() => {
    if (
      status === ContentDisplayLoadingStatus.Uninitialized &&
      accessToken !== ''
    ) {
      dispatch(loadTrendingTopicsForUser(accessToken));
    }
  }, [accessToken, status]);

  const handleTopicAdded = (x: TopicViewModel) => {
    dispatch(saveTrendingTopicForUser(user?.access_token ?? '', x));
  };

  if (accessToken === '' || trendingTopics.length === 0) {
    return null;
  }

  return (
    <div className={styles.suggestedTopicsContainer}>
      <h6>Topics to Follow</h6>
      <p>
        Here are suggestions for topics that may interest you. Add a topic and
        your Most Recent Content will be updated as new information becomes
        available.
      </p>
      <div className={styles.topicsList}>
        {trendingTopics.map((x) => (
          <div key={x.termSetMapId} className={styles.topicListEntry}>
            <button type="button" onClick={() => handleTopicAdded(x)}>
              Add +
            </button>
            <a href={x.url}>{x.description}</a>
          </div>
        ))}
      </div>
      <a href="/topics/">Browse Topics &gt;</a>
    </div>
  );
};

export default SuggestedTopics;
